import actions, { EnvironmentAction } from './actions'
import reducer, { EnvironmentState } from './reducer'
import selectors from './selectors'

export {
  actions,
  selectors,
  EnvironmentAction,
  EnvironmentState
}

export default reducer



// WEBPACK FOOTER //
// ./src/store/environment/index.ts